/**
 * Redirects the user to the login page.
 * Centralized utility to ensure consistent redirect behavior.
 * 
 * @param reason - Optional reason for debugging (logged to console)
 */
export function redirectToLogin(reason?: string): void {
  if (reason) {
    console.warn(`Redirecting to login: ${reason}`);
  }
  
  // Use window.location.href for hard redirect (clears all state)
  window.location.href = "/auth/login";
}
